import type { AuthUser, LoginInput } from '@plane/shared';
import { createContext, use } from 'react';

/**
 * Estado da sessão no painel.
 *
 * `carregando` é `true` só na primeira verificação, ao abrir o painel. Distinguir
 * "ainda não sei" de "não há sessão" é o que impede a tela de login de piscar
 * para quem está autenticado — sem isso, todo F5 mostraria o login por um
 * instante antes de redirecionar de volta.
 */
export interface AuthState {
  readonly usuario: AuthUser | null;
  readonly carregando: boolean;
  readonly entrar: (input: LoginInput) => Promise<void>;
  readonly sair: () => Promise<void>;
}

/**
 * Fica em arquivo próprio, separado do provider: um módulo que exporta
 * componente e hook ao mesmo tempo quebra o fast refresh do Vite.
 */
export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const contexto = use(AuthContext);

  if (!contexto) {
    throw new Error('useAuth precisa estar dentro de <AuthProvider>.');
  }

  return contexto;
}
